<template>
	<v-row no-gutters>
		<v-col cols='12' class='text-center'>
			<slot name='header' :icon='faIcon' :sortition='sortition' :date='formattedDate'>
				<font-awesome-icon :icon='faIcon' />
				<span class='mx-2 font-weight-bold text-subtitle-2'>{{ formattedTime }}</span>
			</slot>
		</v-col>
		<v-col cols='12'>
			<v-row v-if='sortition.result.first || sortition.result.second || sortition.result.third'
						 no-gutters
						 justify='center'>
				<v-col cols='auto' class='d-flex'>
					<digit-image-display :image-dimensions='imageDimensions'
															 :display-as-one="displayAsOne"
															 :digit='sortition.result.first' />
					<v-divider v-if="!displayAsOne" class="numbers-divider" vertical></v-divider>
					<digit-image-display :image-dimensions='imageDimensions'
															 :display-as-one="displayAsOne"
															 :digit='sortition.result.second' />
					<v-divider v-if="!displayAsOne" class="numbers-divider" vertical></v-divider>
					<digit-image-display :image-dimensions='imageDimensions'
															 :display-as-one="displayAsOne"
															 :digit='sortition.result.third' />
				</v-col>
			</v-row>
			<v-row no-gutters justify='center' align-content='center'>
				<v-col v-if='sortition.result.cashThree' cols='auto' class='d-flex'>
					<digit-image-display :image-dimensions='imageDimensions'
															 :digit='sortition.result.cashThree' />
				</v-col>
				<font-awesome-icon v-if='sortition.result.cashThree && sortition.result.pickFour'
													 class='d-flex align-self-center mx-2 divide-icon'
													 icon='circle' />
				<v-col v-if='sortition.result.pickFour' cols='auto' class='d-flex'>
					<digit-image-display :image-dimensions='imageDimensions'
															 :digit='sortition.result.pickFour' />
				</v-col>
			</v-row>
			<v-row v-if='showPickFive' no-gutters justify='center' align-content='center'>
				<v-col v-if='sortition.result.pickFive' cols='auto' class='d-flex'>
					<digit-image-display :image-dimensions='imageDimensions'
					                     :digit='sortition.result.pickFive' />
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import moment from 'moment';
import DigitImageDisplay from '@homepage/components/DigitImageDisplay.vue';

export default {
	name: 'SortitionResult',
	inject: ['generalInformation'],
	components: { DigitImageDisplay },
	props: {
		sortition: {
			type: Object,
			required: true
		},
		imageDimensions: {
			type: Object,
			default: () => ({
				height: 33,
				width: 33
			})
		},
		showPickFive: {
			type: Boolean,
			default: false
		},
		displayAsOne: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		formattedDate() {
			return moment(this.sortition.time).
				tz(this.generalInformation.serverTimeZone).
				format('yyyy-MM-DD');
		},
		formattedTime() {
			return moment(this.sortition.time).
				tz(this.generalInformation.serverTimeZone).
				format('dddd, MMM DD, Y');
		},
		faIcon() {
			const sortitionTimeHours = parseInt(moment(this.sortition.time).
				tz(this.generalInformation.serverTimeZone).
				format('HH'), 10);

			return sortitionTimeHours >= 18 ?
				'moon' :
				'sun';
		}
	}
};
</script>

<style scoped>
.divide-icon {
	font-size: 60%;
}

svg[data-icon='sun'] {
	color: gold;
}

svg[data-icon='moon'] {
	color: cornflowerblue;
}
</style>
